module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-04-18",
		"endpointPrefix": "cognito-idp",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Cognito Identity Provider",
		"signatureVersion": "v4",
		"targetPrefix": "AWSCognitoIdentityProviderService",
		"uid": "cognito-idp-2016-04-18"
	},
	"operations": {
		"AddCustomAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"CustomAttributes"
				],
				"members": {
					"UserPoolId": {},
					"CustomAttributes": {
						"type": "list",
						"member": {
							"shape": "S4"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminAddUserToGroup": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"GroupName"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"GroupName": {}
				}
			}
		},
		"AdminConfirmSignUp": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminCreateUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"ValidationData": {
						"shape": "Si"
					},
					"TemporaryPassword": {
						"shape": "Sm"
					},
					"ForceAliasCreation": {
						"type": "boolean"
					},
					"MessageAction": {},
					"DesiredDeliveryMediums": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "Ss"
					}
				}
			}
		},
		"AdminDeleteUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			}
		},
		"AdminDeleteUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"UserAttributeNames"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributeNames": {
						"shape": "Sz"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminDisableProviderForUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"User"
				],
				"members": {
					"UserPoolId": {},
					"User": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminDisableUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminEnableUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminForgetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"DeviceKey"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"DeviceKey": {}
				}
			}
		},
		"AdminGetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey",
					"UserPoolId",
					"Username"
				],
				"members": {
					"DeviceKey": {},
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Device"
				],
				"members": {
					"Device": {
						"shape": "S1d"
					}
				}
			}
		},
		"AdminGetUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Username"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"UserCreateDate": {
						"type": "timestamp"
					},
					"UserLastModifiedDate": {
						"type": "timestamp"
					},
					"Enabled": {
						"type": "boolean"
					},
					"UserStatus": {},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			}
		},
		"AdminInitiateAuth": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId",
					"AuthFlow"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					},
					"AuthFlow": {},
					"AuthParameters": {
						"shape": "S1j"
					},
					"ClientMetadata": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1o"
					},
					"AuthenticationResult": {
						"shape": "S1p"
					}
				}
			}
		},
		"AdminLinkProviderForUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"DestinationUser",
					"SourceUser"
				],
				"members": {
					"UserPoolId": {},
					"DestinationUser": {
						"shape": "S12"
					},
					"SourceUser": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminListDevices": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Devices": {
						"shape": "S1z"
					},
					"PaginationToken": {}
				}
			}
		},
		"AdminListGroupsForUser": {
			"input": {
				"type": "structure",
				"required": [
					"Username",
					"UserPoolId"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserPoolId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Groups": {
						"shape": "S23"
					},
					"NextToken": {}
				}
			}
		},
		"AdminRemoveUserFromGroup": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"GroupName"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"GroupName": {}
				}
			}
		},
		"AdminResetUserPassword": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminRespondToAuthChallenge": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId",
					"ChallengeName"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					},
					"ChallengeName": {},
					"ChallengeResponses": {
						"shape": "S2c"
					},
					"Session": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1o"
					},
					"AuthenticationResult": {
						"shape": "S1p"
					}
				}
			}
		},
		"AdminSetUserSettings": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"MFAOptions"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUpdateDeviceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"DeviceKey"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"DeviceKey": {},
					"DeviceRememberedStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUpdateUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"UserAttributes"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUserGlobalSignOut": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ChangePassword": {
			"input": {
				"type": "structure",
				"required": [
					"PreviousPassword",
					"ProposedPassword",
					"AccessToken"
				],
				"members": {
					"PreviousPassword": {
						"shape": "Sm"
					},
					"ProposedPassword": {
						"shape": "Sm"
					},
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"ConfirmDevice": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"DeviceKey": {},
					"DeviceSecretVerifierConfig": {
						"type": "structure",
						"members": {
							"PasswordVerifier": {},
							"Salt": {}
						}
					},
					"DeviceName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserConfirmationNecessary": {
						"type": "boolean"
					}
				}
			}
		},
		"ConfirmForgotPassword": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"ConfirmationCode",
					"Password"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					},
					"ConfirmationCode": {},
					"Password": {
						"shape": "Sm"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"ConfirmSignUp": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"ConfirmationCode"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					},
					"ConfirmationCode": {},
					"ForceAliasCreation": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"CreateGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {},
					"Description": {},
					"RoleArn": {},
					"Precedence": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Group": {
						"shape": "S24"
					}
				}
			}
		},
		"CreateIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName",
					"ProviderType",
					"ProviderDetails"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {},
					"ProviderType": {},
					"ProviderDetails": {
						"shape": "S34"
					},
					"AttributeMapping": {
						"shape": "S35"
					},
					"IdpIdentifiers": {
						"shape": "S37"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S3a"
					}
				}
			}
		},
		"CreateResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier",
					"Name"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {},
					"Name": {},
					"Scopes": {
						"shape": "S3e"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServer"
				],
				"members": {
					"ResourceServer": {
						"shape": "S3j"
					}
				}
			}
		},
		"CreateUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"JobName",
					"UserPoolId",
					"CloudWatchLogsRoleArn"
				],
				"members": {
					"JobName": {},
					"UserPoolId": {},
					"CloudWatchLogsRoleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S3n"
					}
				}
			}
		},
		"CreateUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"PoolName"
				],
				"members": {
					"PoolName": {},
					"Policies": {
						"shape": "S3v"
					},
					"LambdaConfig": {
						"shape": "S3y"
					},
					"AutoVerifiedAttributes": {
						"shape": "S3z"
					},
					"AliasAttributes": {
						"shape": "S41"
					},
					"UsernameAttributes": {
						"shape": "S43"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"VerificationMessageTemplate": {
						"shape": "S48"
					},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S4d"
					},
					"EmailConfiguration": {
						"shape": "S4e"
					},
					"SmsConfiguration": {
						"shape": "S4g"
					},
					"UserPoolTags": {
						"shape": "S4h"
					},
					"AdminCreateUserConfig": {
						"shape": "S4i"
					},
					"Schema": {
						"shape": "S4l"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPool": {
						"shape": "S4n"
					}
				}
			}
		},
		"CreateUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientName"
				],
				"members": {
					"UserPoolId": {},
					"ClientName": {},
					"GenerateSecret": {
						"type": "boolean"
					},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S4t"
					},
					"WriteAttributes": {
						"shape": "S4t"
					},
					"ExplicitAuthFlows": {
						"shape": "S4v"
					},
					"SupportedIdentityProviders": {
						"shape": "S4x"
					},
					"CallbackURLs": {
						"shape": "S4y"
					},
					"LogoutURLs": {
						"shape": "S50"
					},
					"DefaultRedirectURI": {},
					"AllowedOAuthFlows": {
						"shape": "S51"
					},
					"AllowedOAuthScopes": {
						"shape": "S53"
					},
					"AllowedOAuthFlowsUserPoolClient": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S56"
					}
				}
			}
		},
		"CreateUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain",
					"UserPoolId"
				],
				"members": {
					"Domain": {},
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {}
				}
			}
		},
		"DeleteIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {}
				}
			}
		},
		"DeleteResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {}
				}
			}
		},
		"DeleteUser": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"authtype": "none"
		},
		"DeleteUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserAttributeNames",
					"AccessToken"
				],
				"members": {
					"UserAttributeNames": {
						"shape": "Sz"
					},
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"DeleteUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			}
		},
		"DeleteUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					}
				}
			}
		},
		"DeleteUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain",
					"UserPoolId"
				],
				"members": {
					"Domain": {},
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S3a"
					}
				}
			}
		},
		"DescribeResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServer"
				],
				"members": {
					"ResourceServer": {
						"shape": "S3j"
					}
				}
			}
		},
		"DescribeUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S3n"
					}
				}
			}
		},
		"DescribeUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPool": {
						"shape": "S4n"
					}
				}
			}
		},
		"DescribeUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S56"
					}
				}
			}
		},
		"DescribeUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain"
				],
				"members": {
					"Domain": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DomainDescription": {
						"type": "structure",
						"members": {
							"UserPoolId": {},
							"AWSAccountId": {},
							"Domain": {},
							"S3Bucket": {},
							"CloudFrontDistribution": {},
							"Version": {},
							"Status": {}
						}
					}
				}
			}
		},
		"ForgetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"DeviceKey": {}
				}
			}
		},
		"ForgotPassword": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S65"
					}
				}
			},
			"authtype": "none"
		},
		"GetCSVHeader": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"CSVHeader": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"GetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey"
				],
				"members": {
					"DeviceKey": {},
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Device"
				],
				"members": {
					"Device": {
						"shape": "S1d"
					}
				}
			}
		},
		"GetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Group": {
						"shape": "S24"
					}
				}
			}
		},
		"GetIdentityProviderByIdentifier": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"IdpIdentifier"
				],
				"members": {
					"UserPoolId": {},
					"IdpIdentifier": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S3a"
					}
				}
			}
		},
		"GetUICustomization": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"UICustomization"
				],
				"members": {
					"UICustomization": {
						"shape": "S6h"
					}
				}
			}
		},
		"GetUser": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Username",
					"UserAttributes"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"authtype": "none"
		},
		"GetUserAttributeVerificationCode": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"AttributeName"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"AttributeName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S65"
					}
				}
			},
			"authtype": "none"
		},
		"GlobalSignOut": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"InitiateAuth": {
			"input": {
				"type": "structure",
				"required": [
					"AuthFlow",
					"ClientId"
				],
				"members": {
					"AuthFlow": {},
					"AuthParameters": {
						"shape": "S1j"
					},
					"ClientMetadata": {
						"shape": "S1k"
					},
					"ClientId": {
						"shape": "S1h"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1o"
					},
					"AuthenticationResult": {
						"shape": "S1p"
					}
				}
			}
		},
		"ListDevices": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Devices": {
						"shape": "S1z"
					},
					"PaginationToken": {}
				}
			}
		},
		"ListGroups": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Groups": {
						"shape": "S23"
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentityProviders": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Providers"
				],
				"members": {
					"Providers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ProviderName": {},
								"ProviderType": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"CreationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListResourceServers": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServers"
				],
				"members": {
					"ResourceServers": {
						"type": "list",
						"member": {
							"shape": "S3j"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUserImportJobs": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"MaxResults"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJobs": {
						"type": "list",
						"member": {
							"shape": "S3n"
						}
					},
					"PaginationToken": {}
				}
			}
		},
		"ListUserPoolClients": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClients": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ClientId": {
									"shape": "S1h"
								},
								"UserPoolId": {},
								"ClientName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUserPools": {
			"input": {
				"type": "structure",
				"required": [
					"MaxResults"
				],
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPools": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"LambdaConfig": {
									"shape": "S3y"
								},
								"Status": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"CreationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUsers": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"AttributesToGet": {
						"type": "list",
						"member": {}
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {},
					"Filter": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"shape": "S7o"
					},
					"PaginationToken": {}
				}
			}
		},
		"ListUsersInGroup": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"GroupName"
				],
				"members": {
					"UserPoolId": {},
					"GroupName": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"shape": "S7o"
					},
					"NextToken": {}
				}
			}
		},
		"ResendConfirmationCode": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S65"
					}
				}
			},
			"authtype": "none"
		},
		"RespondToAuthChallenge": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"ChallengeName"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"ChallengeName": {},
					"Session": {},
					"ChallengeResponses": {
						"shape": "S2c"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1o"
					},
					"AuthenticationResult": {
						"shape": "S1p"
					}
				}
			}
		},
		"SetUICustomization": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					},
					"CSS": {},
					"ImageFile": {
						"type": "blob"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"UICustomization"
				],
				"members": {
					"UICustomization": {
						"shape": "S6h"
					}
				}
			}
		},
		"SetUserSettings": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"MFAOptions"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"SignUp": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"Password"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					},
					"Password": {
						"shape": "Sm"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"ValidationData": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"UserConfirmed",
					"UserSub"
				],
				"members": {
					"UserConfirmed": {
						"type": "boolean"
					},
					"CodeDeliveryDetails": {
						"shape": "S65"
					},
					"UserSub": {}
				}
			},
			"authtype": "none"
		},
		"StartUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S3n"
					}
				}
			}
		},
		"StopUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S3n"
					}
				}
			}
		},
		"UpdateDeviceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"DeviceKey": {},
					"DeviceRememberedStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {},
					"Description": {},
					"RoleArn": {},
					"Precedence": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Group": {
						"shape": "S24"
					}
				}
			}
		},
		"UpdateIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {},
					"ProviderDetails": {
						"shape": "S34"
					},
					"AttributeMapping": {
						"shape": "S35"
					},
					"IdpIdentifiers": {
						"shape": "S37"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S3a"
					}
				}
			}
		},
		"UpdateResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier",
					"Name"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {},
					"Name": {},
					"Scopes": {
						"shape": "S3e"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServer"
				],
				"members": {
					"ResourceServer": {
						"shape": "S3j"
					}
				}
			}
		},
		"UpdateUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserAttributes",
					"AccessToken"
				],
				"members": {
					"UserAttributes": {
						"shape": "Si"
					},
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetailsList": {
						"type": "list",
						"member": {
							"shape": "S65"
						}
					}
				}
			},
			"authtype": "none"
		},
		"UpdateUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"Policies": {
						"shape": "S3v"
					},
					"LambdaConfig": {
						"shape": "S3y"
					},
					"AutoVerifiedAttributes": {
						"shape": "S3z"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"VerificationMessageTemplate": {
						"shape": "S48"
					},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S4d"
					},
					"EmailConfiguration": {
						"shape": "S4e"
					},
					"SmsConfiguration": {
						"shape": "S4g"
					},
					"UserPoolTags": {
						"shape": "S4h"
					},
					"AdminCreateUserConfig": {
						"shape": "S4i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					},
					"ClientName": {},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S4t"
					},
					"WriteAttributes": {
						"shape": "S4t"
					},
					"ExplicitAuthFlows": {
						"shape": "S4v"
					},
					"SupportedIdentityProviders": {
						"shape": "S4x"
					},
					"CallbackURLs": {
						"shape": "S4y"
					},
					"LogoutURLs": {
						"shape": "S50"
					},
					"DefaultRedirectURI": {},
					"AllowedOAuthFlows": {
						"shape": "S51"
					},
					"AllowedOAuthScopes": {
						"shape": "S53"
					},
					"AllowedOAuthFlowsUserPoolClient": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S56"
					}
				}
			}
		},
		"VerifyUserAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"AttributeName",
					"Code"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"AttributeName": {},
					"Code": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"Name": {},
				"AttributeDataType": {},
				"DeveloperOnlyAttribute": {
					"type": "boolean"
				},
				"Mutable": {
					"type": "boolean"
				},
				"Required": {
					"type": "boolean"
				},
				"NumberAttributeConstraints": {
					"type": "structure",
					"members": {
						"MinValue": {},
						"MaxValue": {}
					}
				},
				"StringAttributeConstraints": {
					"type": "structure",
					"members": {
						"MinLength": {},
						"MaxLength": {}
					}
				}
			}
		},
		"Sd": {
			"type": "string",
			"sensitive": true
		},
		"Si": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Value": {
						"type": "string",
						"sensitive": true
					}
				}
			}
		},
		"Sm": {
			"type": "string",
			"sensitive": true
		},
		"Ss": {
			"type": "structure",
			"members": {
				"Username": {
					"shape": "Sd"
				},
				"Attributes": {
					"shape": "Si"
				},
				"UserCreateDate": {
					"type": "timestamp"
				},
				"UserLastModifiedDate": {
					"type": "timestamp"
				},
				"Enabled": {
					"type": "boolean"
				},
				"UserStatus": {},
				"MFAOptions": {
					"shape": "Sv"
				}
			}
		},
		"Sv": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"DeliveryMedium": {},
					"AttributeName": {}
				}
			}
		},
		"Sz": {
			"type": "list",
			"member": {}
		},
		"S12": {
			"type": "structure",
			"members": {
				"ProviderName": {},
				"ProviderAttributeName": {},
				"ProviderAttributeValue": {}
			}
		},
		"S1d": {
			"type": "structure",
			"members": {
				"DeviceKey": {},
				"DeviceAttributes": {
					"shape": "Si"
				},
				"DeviceCreateDate": {
					"type": "timestamp"
				},
				"DeviceLastModifiedDate": {
					"type": "timestamp"
				},
				"DeviceLastAuthenticatedDate": {
					"type": "timestamp"
				}
			}
		},
		"S1h": {
			"type": "string",
			"sensitive": true
		},
		"S1j": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1k": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1o": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1p": {
			"type": "structure",
			"members": {
				"AccessToken": {
					"shape": "S1q"
				},
				"ExpiresIn": {
					"type": "integer"
				},
				"TokenType": {},
				"RefreshToken": {
					"shape": "S1q"
				},
				"IdToken": {
					"shape": "S1q"
				},
				"NewDeviceMetadata": {
					"type": "structure",
					"members": {
						"DeviceKey": {},
						"DeviceGroupKey": {}
					}
				}
			}
		},
		"S1q": {
			"type": "string",
			"sensitive": true
		},
		"S1z": {
			"type": "list",
			"member": {
				"shape": "S1d"
			}
		},
		"S23": {
			"type": "list",
			"member": {
				"shape": "S24"
			}
		},
		"S24": {
			"type": "structure",
			"members": {
				"GroupName": {},
				"UserPoolId": {},
				"Description": {},
				"RoleArn": {},
				"Precedence": {
					"type": "integer"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				}
			}
		},
		"S2c": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S2u": {
			"type": "string",
			"sensitive": true
		},
		"S34": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S35": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S37": {
			"type": "list",
			"member": {}
		},
		"S3a": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ProviderName": {},
				"ProviderType": {},
				"ProviderDetails": {
					"shape": "S34"
				},
				"AttributeMapping": {
					"shape": "S35"
				},
				"IdpIdentifiers": {
					"shape": "S37"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				}
			}
		},
		"S3e": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"ScopeName",
					"ScopeDescription"
				],
				"members": {
					"ScopeName": {},
					"ScopeDescription": {}
				}
			}
		},
		"S3j": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"Identifier": {},
				"Name": {},
				"Scopes": {
					"shape": "S3e"
				}
			}
		},
		"S3n": {
			"type": "structure",
			"members": {
				"JobName": {},
				"JobId": {},
				"UserPoolId": {},
				"PreSignedUrl": {},
				"CreationDate": {
					"type": "timestamp"
				},
				"StartDate": {
					"type": "timestamp"
				},
				"CompletionDate": {
					"type": "timestamp"
				},
				"Status": {},
				"CloudWatchLogsRoleArn": {},
				"ImportedUsers": {
					"type": "long"
				},
				"SkippedUsers": {
					"type": "long"
				},
				"FailedUsers": {
					"type": "long"
				},
				"CompletionMessage": {}
			}
		},
		"S3v": {
			"type": "structure",
			"members": {
				"PasswordPolicy": {
					"type": "structure",
					"members": {
						"MinimumLength": {
							"type": "integer"
						},
						"RequireUppercase": {
							"type": "boolean"
						},
						"RequireLowercase": {
							"type": "boolean"
						},
						"RequireNumbers": {
							"type": "boolean"
						},
						"RequireSymbols": {
							"type": "boolean"
						}
					}
				}
			}
		},
		"S3y": {
			"type": "structure",
			"members": {
				"PreSignUp": {},
				"CustomMessage": {},
				"PostConfirmation": {},
				"PreAuthentication": {},
				"PostAuthentication": {},
				"DefineAuthChallenge": {},
				"CreateAuthChallenge": {},
				"VerifyAuthChallengeResponse": {}
			}
		},
		"S3z": {
			"type": "list",
			"member": {}
		},
		"S41": {
			"type": "list",
			"member": {}
		},
		"S43": {
			"type": "list",
			"member": {}
		},
		"S48": {
			"type": "structure",
			"members": {
				"SmsMessage": {},
				"EmailMessage": {},
				"EmailSubject": {},
				"EmailMessageByLink": {},
				"EmailSubjectByLink": {},
				"DefaultEmailOption": {}
			}
		},
		"S4d": {
			"type": "structure",
			"members": {
				"ChallengeRequiredOnNewDevice": {
					"type": "boolean"
				},
				"DeviceOnlyRememberedOnUserPrompt": {
					"type": "boolean"
				}
			}
		},
		"S4e": {
			"type": "structure",
			"members": {
				"SourceArn": {},
				"ReplyToEmailAddress": {}
			}
		},
		"S4g": {
			"type": "structure",
			"required": [
				"SnsCallerArn"
			],
			"members": {
				"SnsCallerArn": {},
				"ExternalId": {}
			}
		},
		"S4h": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S4i": {
			"type": "structure",
			"members": {
				"AllowAdminCreateUserOnly": {
					"type": "boolean"
				},
				"UnusedAccountValidityDays": {
					"type": "integer"
				},
				"InviteMessageTemplate": {
					"type": "structure",
					"members": {
						"SMSMessage": {},
						"EmailMessage": {},
						"EmailSubject": {}
					}
				}
			}
		},
		"S4l": {
			"type": "list",
			"member": {
				"shape": "S4"
			}
		},
		"S4n": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"Policies": {
					"shape": "S3v"
				},
				"LambdaConfig": {
					"shape": "S3y"
				},
				"Status": {},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"SchemaAttributes": {
					"shape": "S4l"
				},
				"AutoVerifiedAttributes": {
					"shape": "S3z"
				},
				"AliasAttributes": {
					"shape": "S41"
				},
				"UsernameAttributes": {
					"shape": "S43"
				},
				"SmsVerificationMessage": {},
				"EmailVerificationMessage": {},
				"EmailVerificationSubject": {},
				"VerificationMessageTemplate": {
					"shape": "S48"
				},
				"SmsAuthenticationMessage": {},
				"MfaConfiguration": {},
				"DeviceConfiguration": {
					"shape": "S4d"
				},
				"EstimatedNumberOfUsers": {
					"type": "integer"
				},
				"EmailConfiguration": {
					"shape": "S4e"
				},
				"SmsConfiguration": {
					"shape": "S4g"
				},
				"UserPoolTags": {
					"shape": "S4h"
				},
				"SmsConfigurationFailure": {},
				"EmailConfigurationFailure": {},
				"AdminCreateUserConfig": {
					"shape": "S4i"
				}
			}
		},
		"S4t": {
			"type": "list",
			"member": {}
		},
		"S4v": {
			"type": "list",
			"member": {}
		},
		"S4x": {
			"type": "list",
			"member": {}
		},
		"S4y": {
			"type": "list",
			"member": {}
		},
		"S50": {
			"type": "list",
			"member": {}
		},
		"S51": {
			"type": "list",
			"member": {}
		},
		"S53": {
			"type": "list",
			"member": {}
		},
		"S56": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ClientName": {},
				"ClientId": {
					"shape": "S1h"
				},
				"ClientSecret": {
					"type": "string",
					"sensitive": true
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"RefreshTokenValidity": {
					"type": "integer"
				},
				"ReadAttributes": {
					"shape": "S4t"
				},
				"WriteAttributes": {
					"shape": "S4t"
				},
				"ExplicitAuthFlows": {
					"shape": "S4v"
				},
				"SupportedIdentityProviders": {
					"shape": "S4x"
				},
				"CallbackURLs": {
					"shape": "S4y"
				},
				"LogoutURLs": {
					"shape": "S50"
				},
				"DefaultRedirectURI": {},
				"AllowedOAuthFlows": {
					"shape": "S51"
				},
				"AllowedOAuthScopes": {
					"shape": "S53"
				},
				"AllowedOAuthFlowsUserPoolClient": {
					"type": "boolean"
				}
			}
		},
		"S65": {
			"type": "structure",
			"members": {
				"Destination": {},
				"DeliveryMedium": {},
				"AttributeName": {}
			}
		},
		"S6h": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ClientId": {
					"shape": "S1h"
				},
				"ImageUrl": {},
				"CSS": {},
				"CSSVersion": {},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				}
			}
		},
		"S7o": {
			"type": "list",
			"member": {
				"shape": "Ss"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cognito-idp-2016-04-18.min.json
// module id = 579
// module chunks = 0